<div class="toolbar-container">
  <app-agile-board-add-column></app-agile-board-add-column>
  <app-agile-board-color-options></app-agile-board-color-options>
  <app-agile-board-sort></app-agile-board-sort>
</div>
